import React from "react";
import { FiInfo } from "react-icons/fi";

interface InstructionsInfoBoxProps {
	title?: string;
	children: React.ReactNode;
}

export const InstructionsInfoBox: React.FC<InstructionsInfoBoxProps> = ({
	title,
	children,
}) => {
	return (
		<div
			className="rounded-lg border border-blue-200 bg-blue-50 p-4 flex gap-3"
			data-testid="instructions-info-box"
		>
			<FiInfo
				className="text-blue-500 flex-shrink-0 mt-0.5"
				size={20}
				aria-hidden="true"
			/>
			<div>
				{title && (
					<p className="font-semibold text-blue-800 mb-1">{title}</p>
				)}
				<div className="text-blue-700 text-sm">{children}</div>
			</div>
		</div>
	);
};
